module.exports = __webpack_public_path__ + "h5/img/PDF1.798bf832.jpg";